import React, { useState, useEffect, ReactNode } from "react"

import UIHeader from "@ecom/ui/components/HeaderNew"

import { LogoBlueV2 } from "@ecom/ui/components/Header/Main/LogoV2"
import { pushToDataLayerOnce } from "@ecom/ui/utils/pushToDataLayerUtils"
import clsx from "clsx"
import * as styles from "./header.module.scss"
import { useObserverSticky } from "../../hooks/useObserverSticky"
import { handleClickHeaderButton } from "../../helpers/WatcherDL/utils/handleClickBanner"

export type HeaderProps = {
  phones?: string[]
  withButton?: boolean
  withPhone?: boolean
  children?: ReactNode
  ButtonProps?: any
  Logo?: any
  buttonText?: string
  right?: React.ReactNode
  hasLink?: boolean
  withShadow?: boolean
  stickyMode?: boolean
  backgroundColor?: string
  logoLink?: string
  ABPhone?: boolean
  variantStyle?: string
}

type PhoneProps = {
  phones?: string[] | null
  phoneHint?: string | null
  classes?: object | null
}

export function Header({
  phones,
  withButton,
  withPhone = true,
  children,
  ButtonProps = {
    onClick: () => handleClickHeaderButton("sticky"),
    classes: styles,
  },
  Logo = LogoBlueV2,
  buttonText,
  right,
  hasLink = false,
  stickyMode = true,
  withShadow,
  backgroundColor,
  logoLink = "https://sovcombank.ru/",
  ABPhone = false,
  variantStyle,
}: HeaderProps) {
  const [phoneProps, setPhoneProps] = useState<PhoneProps>({
    phones: [],
    phoneHint: null,
    classes: null,
  })

  const isSticky = useObserverSticky()

  useEffect(() => {
    setPhoneProps({
      phones,
      phoneHint: undefined,
      classes: !withPhone ? { phoneContainer: "hide" } : undefined,
    })
  }, [phones, withPhone])

  const handleButtonClick = () => {
    pushToDataLayerOnce("logo-header", {
      event: "buttonClick",
      placement: "logo-header",
    })
  }

  const LogoWithLink = () => (
    <a
      href={logoLink}
      target="_blank"
      rel="noreferrer"
      onClick={handleButtonClick}
    >
      <Logo />
    </a>
  )

  const LogoWithoutLink = () => (
    <div role="presentation" onClick={handleButtonClick}>
      <Logo />
    </div>
  )

  return (
    <UIHeader
      ABphone={ABPhone}
      withButton={withButton}
      PhoneProps={phoneProps}
      ButtonProps={{
        ...ButtonProps,
        children: buttonText ?? "Оформить",
        className: clsx(styles.btnRoot, variantStyle && styles[variantStyle]),
      }}
      sticky={stickyMode ? isSticky : stickyMode}
      left={hasLink ? <LogoWithLink /> : <LogoWithoutLink />}
      right={right}
      withShadow={withShadow}
      backgroundColor={backgroundColor}
    >
      {children}
    </UIHeader>
  )
}
